import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'

import Apart1TopSection from '@/features/apart/components/Apart1TopSection'
import Apart2DescSection from '@/features/apart/components/Apart2DescSection'
import Apart3StepSection from '@/features/apart/components/Apart3StepSection'
import Apart4InquirySection from '@/features/apart/components/Apart4InquirySection'
import ApartFooter from '@/features/apart/components/ApartFooter'
import ApartHeader from '@/features/apart/components/ApartHeader'
import ApartSideFloat from '@/features/apart/components/ApartSideFloat'
import ApartTerms from '@/features/apart/components/ApartTerms'
import { modalControl } from '@/shared/recoil/common/atom'
import { BackGroundGradient } from '@/styles/Web/Apart/styled'

const Apart = () => {
  const { pathname } = useLocation()
  const setMypagemodal = useSetRecoilState(modalControl)

  useEffect(() => {
    setMypagemodal(false)
  }, [setMypagemodal])

  return (
    <>
      <ApartHeader />
      {pathname.indexOf('b2b/terms') > 0 ? (
        <ApartTerms />
      ) : (
        <>
          <Apart1TopSection />
          <Apart2DescSection />
          <BackGroundGradient>
            <Apart3StepSection />
            <Apart4InquirySection />
          </BackGroundGradient>
          {/* <Apart5AgencySection /> */}
          <ApartSideFloat />
        </>
      )}
      <ApartFooter />
    </>
  )
}
export default Apart
